// Translation of the algorithm described by https://en.wikipedia.org/wiki/Damerau%E2%80%93Levenshtein_distance#Distance_with_adjacent_transpositions
export function damerauLevenshteinDistance(a: string, b: string): { distance: number; similarity: number } {
  const alphabet = new Set(a.split('').concat(b.split('')).sort());
  const charLastSeenIndex: Record<string, number> = {};
  for (const char of alphabet) {
    charLastSeenIndex[char] = 0;
  }
  const distances: Record<number, Record<number, number>> = {};
  for (let i = -1; i <= a.length; i++) {
    distances[i] = {};
  }

  const maxDistance = a.length + b.length;
  distances[-1][-1] = maxDistance;
  for (let i = 0; i <= a.length; i++) {
    distances[i][-1] = maxDistance;
    distances[i][0] = i;
  }
  for (let j = 0; j <= b.length; j++) {
    distances[-1][j] = maxDistance;
    distances[0][j] = j;
  }

  for (let aIndex = 1; aIndex <= a.length; aIndex++) {
    let lastMatchIndex = 0;
    for (let bIndex = 1; bIndex <= b.length; bIndex++) {
      const oldLastMatchIndex = lastMatchIndex;
      let cost: number;
      if (a[aIndex - 1] === b[bIndex - 1]) {
        cost = 0;
        lastMatchIndex = bIndex;
      } else {
        cost = 1;
      }

      const charLastSeenAt = charLastSeenIndex[b[bIndex - 1]];
      distances[aIndex][bIndex] = Math.min(
        distances[aIndex - 1][bIndex - 1] + cost, // Substitution
        distances[aIndex][bIndex - 1] + 1, // Insertion
        distances[aIndex - 1][bIndex] + 1, // Deletion
        distances[charLastSeenAt - 1][oldLastMatchIndex - 1] +
          (aIndex - charLastSeenAt - 1) +
          cost +
          (bIndex - oldLastMatchIndex - 1), // Transposition
      );
    }
    charLastSeenIndex[a[aIndex - 1]] = aIndex;
  }

  const distance = distances[a.length][b.length];
  return {
    distance,
    similarity: 1 - distance / Math.max(a.length, b.length),
  };
}
